import { useEffect, useState } from 'react';
import OInput from '../../../../UI/FormControls/OInput';
import { useTranslation } from 'react-i18next';

const INITIAL_VALUES = {
  nazivFirme: '',
};
const SearchForm = ({
  setKlijentiData,
  klijentiData,
  filterValues,
  setFilterValues,
}) => {
  const { t, i18n } = useTranslation();
  // const [filterValues, setFilterValues] = useState(INITIAL_VALUES);

  useEffect(() => {
    const filterList = klijentiData.source.filter((item) =>
      item.nazivFirme
        .toLowerCase()
        .includes(filterValues.nazivFirme.toLowerCase()),
    );
    setKlijentiData((curr) => {
      return { ...curr, filtered: filterList };
    });
  }, [filterValues]);

  const handleChange = (e) => {
    setFilterValues((curr) => {
      return { ...curr, [e.target.name]: e.target.value };
    });
  };
  return (
    <div>
      {' '}
      <OInput
        label={`${t('search')} `}
        name="nazivFirme"
        value={filterValues.nazivFirme}
        handleChange={handleChange}
        style={{ width: '100%' }}
      />
    </div>
  );
};

export default SearchForm;
